import { addCommas } from "@domains/utils/numberMethods";
export var ViewIncomeDeclarationMapper = function (data) {
    var result = {};
    if (data && data.length > 0) {
        var resultObj = {
            accountCode: data[0].account_code,
            grossAnnualIncRangeCode: data[0].gross_annual_inc_range_code,
            grossAnnualIncomeDate: data[0].gross_annual_income_date,
            networthDate: data[0].networth_date,
            incomeNetworthFlag: data[0].income_networth_flag,
            networth: addCommas(data[0].networth),
            amlRisk: data[0].aml_risk,
            annualIncomeRange: data[0].annual_income_range,
        };
        result = resultObj;
    }
    return result;
};
